import { z } from "zod";

const validateTime = (x: string | null) => {
  if (x === null) return true;
  const requiredFullSize = 'xxxxxxxx'.length;
  const normalized = x.replaceAll(/\D/g, '');
  return normalized.length === 0 || normalized.length === requiredFullSize;
}
export const AuditoriaProcessoAauditoriaSchema = z.object({
  IdProcesso: z.number().nullable().optional(),
  IdAuditoria: z.number(),
  Descricao: z.string().min(1, "O campo Processo é obrigatório."),
  FuncionarioNome: z.string().nullable().optional(),
  Data: z.coerce.date({
    invalid_type_error: "O campo Data é obrigatório.",
  }),
  ResponsavelCadastrado: z.boolean().nullable().optional(), 
  DescResponsavel: z.string().nullable().optional(),
  IdFuncionario: z.number().nullable().optional(),
  Horario:z.string().nullable().default(null).refine(validateTime, 'Campo invalido!'),
  RequisitoNormativo: z.string().optional().nullable(), 
  Local: z.number().optional().nullable(), 
})
.superRefine((data, ctx) => {
  if (data.ResponsavelCadastrado === true) {
    if (!data.DescResponsavel || data.DescResponsavel.trim() === "") {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: "O campo Responsável é obrigatório.",
        path: ["DescResponsavel"], 
      });
    }
  } else {
    if (!data.IdFuncionario || data.IdFuncionario === 0) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: "O campo Responsável é obrigatório.",
        path: ["IdFuncionario"], 
      });
    }
  }
});



export type AuditoriaProcessoAauditoriaForm = z.infer<typeof AuditoriaProcessoAauditoriaSchema>;